import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ArrowRightAlt as ArrowIcon, ErrorOutline as ErrorIcon } from '@material-ui/icons';

import { useStyles } from './planScheduleBanner.styles';

function PlanScheduleBanner ({ tone, children }) {
    const classes = useStyles();
    const isCancellation = tone === 'cancellation';
    const Icon = isCancellation ? ErrorIcon : ArrowIcon;

    return (
        <div className={classnames(classes.root, isCancellation ? classes.cancellation : classes.change)} role="status">
            <Icon className={classes.icon} fontSize="small" />
            <span className={classes.text}>{children}</span>
        </div>
    );
}

PlanScheduleBanner.propTypes = {
    tone: PropTypes.oneOf(['upgrade', 'downgrade', 'cancellation']).isRequired,
    children: PropTypes.node.isRequired,
};

export default PlanScheduleBanner;
